/* 
* /Login call response returns challange key, an enum that indicates kind of SCA required 
*/
export enum LOGIN_CHANNEL {
  TOKEN = "PHYS",
  APP_DEVICE = "BIO",
  SMS = "SMS",
}
/* 
* /Login call headers : alue used to specify if the current request is part of 
* an APP Enrollment (device flow) or is requesting the use of a QR code to generate the challenge
*/
export const QR_X_TYPE = "QR";
export const RESEND_NOTIFY_X_TYPE = "RESEND";
